var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "编辑抽奖",
        width: "696px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "addLottery overflowOuto" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": "auto",
                size: "small",
                rules: _vm.rules,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "抽奖名称", prop: "prizeDrawName" } },
                [
                  _c("el-input", {
                    ref: "userInput",
                    staticStyle: { width: "450px" },
                    attrs: {
                      clearable: "",
                      placeholder: "请输入",
                      maxlength: "20",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.prizeDrawName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "prizeDrawName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.prizeDrawName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "参与条件", prop: "participationCondition" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.participationConditionChange },
                      model: {
                        value: _vm.form.participationCondition,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "participationCondition", $$v)
                        },
                        expression: "form.participationCondition",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("用户在线"),
                      ]),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("参与指定评论"),
                      ]),
                    ],
                    1
                  ),
                  _vm.form.participationCondition === 3
                    ? _c("el-input", {
                        staticClass: "m-t-10",
                        attrs: {
                          placeholder: "点击输入指定的评论",
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.assignedComment,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "assignedComment",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.assignedComment",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "奖品设置", prop: "prizeDetail" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addLottery },
                    },
                    [_vm._v("添加奖品")]
                  ),
                  _c("div", { staticClass: "tips" }, [
                    _c("div", [
                      _vm._v("1.拖拽奖品列表可调整奖品在直播间的展示顺序；"),
                    ]),
                    _c("div", [
                      _vm._v(
                        "2.一轮抽奖最多可设置5种奖品，每种奖品最多设置200份；"
                      ),
                    ]),
                  ]),
                  _vm.form.prizeDetail.length > 0
                    ? _c(
                        "el-table",
                        {
                          ref: "elTable",
                          staticClass: "myLotteryTable m-t-10",
                          staticStyle: { width: "547px" },
                          attrs: {
                            border: "",
                            data: _vm.form.prizeDetail,
                            "cell-class-name": "cursorMove",
                            "header-cell-style": { background: "#F3F3F3" },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "sort", width: "32" },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "goodsName",
                              label: "奖品",
                              "min-width": "184",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "prizeType",
                              label: "类型",
                              width: "72",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            {
                                              1: "虚拟商品",
                                              2: "实物商品",
                                              3: "优惠券",
                                            }[row.prizeType]
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1037804075
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "prizeName",
                              label: "奖品名称",
                              width: "130",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "例如：一等奖",
                                          maxlength: "6",
                                        },
                                        model: {
                                          value: row.prizeName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              row,
                                              "prizeName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "row.prizeName",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1800796037
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "amount",
                              label: "份数",
                              width: "74",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("el-input", {
                                        on: {
                                          input: (e) => _vm.delNumber(e, row),
                                        },
                                        model: {
                                          value: row.amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              row,
                                              "amount",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "row.amount",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2305030816
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "", width: "50", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-delete cursorPoninter",
                                        staticStyle: {
                                          color: "#0c6fff",
                                          "font-size": "14px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onhandleDel(row)
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              985157727
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "规则设置", prop: "showParticipantsAmount" },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { "true-label": 1, "false-label": 0 },
                      model: {
                        value: _vm.form.showParticipantsAmount,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "showParticipantsAmount", $$v)
                        },
                        expression: "form.showParticipantsAmount",
                      },
                    },
                    [_vm._v("用户端将展示抽奖参与人数")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "抽奖说明", prop: "prizeInstructions" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "500",
                      "show-word-limit": "",
                      autosize: { minRows: 2, maxRows: 6 },
                    },
                    model: {
                      value: _vm.form.prizeInstructions,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "prizeInstructions",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.prizeInstructions",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("selectGift", {
        attrs: { config: _vm.selectGiftConfig },
        on: { success: _vm.onhandleSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }